// src/components/PostBannerIcon.jsx
import {
  Sword, Trees, Megaphone, Pickaxe, Castle,
  Newspaper, Sparkles, Trophy, Crown, Package, Mountain, Coins,
} from "lucide-react";

const ICON_MAP = {
  Sword, Trees, Megaphone, Pickaxe, Castle,
  Newspaper, Sparkles, Trophy, Crown, Package, Mountain, Coins,
};

export default function PostBannerIcon({ name, size = 44 }) {
  const Icon = ICON_MAP[name] || Sword;
  return <Icon style={{ width: size, height: size }} />;
}
